import type { WidgetDefinition } from "@nexus/widget-sdk";
import { manifest, Component, defaultConfig } from ".";

export const definition: WidgetDefinition = {
  id: "kpi-statistics",
  module: { manifest, Component, defaultConfig },
  catalog: {
    description: "Summarize headline protection performance indicators.",
    domain: "kpis",
    visual: "KPI",
    purposes: ["live"],
    audiences: ["analyst", "client"],
  },
  layout: { kind: "content", skeleton: "kpis", ownsSkeleton: true },
  defaultLayoutClassName: "col-span-12",
};
